import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Shop = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${API}/categories`);
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  return (
    <div className="min-h-screen pt-20" data-testid="shop-page">
      {/* Header */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#141414] border-b border-white/10">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="font-outfit text-4xl sm:text-5xl text-white mb-4">
            Our <span className="gold-gradient">Products</span>
          </h1>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Browse our complete range of print products and services. Click on a category to explore.
          </p>
        </div>
      </section>

      {/* Categories Grid */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {loading ? (
            <div className="flex justify-center py-20">
              <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {categories.map((category, index) => (
                <Link
                  key={category.id}
                  to={`/shop/${category.slug}`}
                  className="group relative overflow-hidden rounded-sm border border-white/10 card-hover"
                  style={{ animationDelay: `${index * 0.1}s` }}
                  data-testid={`shop-category-${category.slug}`}
                >
                  <div className="aspect-[16/9] overflow-hidden">
                    <img
                      src={category.image || "https://images.unsplash.com/photo-1633415565464-e1d69c3fd906?w=800"}
                      alt={category.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-8">
                    <h2 className="font-outfit text-2xl text-white group-hover:text-[#D4AF37] transition-colors mb-2">
                      {category.name}
                    </h2>
                    <span className="text-[#D4AF37] text-sm flex items-center">
                      View Products <ArrowRight size={14} className="ml-1 group-hover:translate-x-1 transition-transform" />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#141414]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-outfit text-2xl text-white mb-4">
            Can't find what you're looking for?
          </h2>
          <p className="text-gray-400 mb-6">
            We offer custom printing solutions. Request a quote for your specific needs.
          </p>
          <Link 
            to="/request-quote" 
            className="btn-gold inline-flex items-center"
            data-testid="shop-quote-btn"
          >
            Request Custom Quote
            <ArrowRight className="ml-2" size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Shop;
